/**
 * Documentation Geoprod
 * Description des web services de Remoteprod
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
  HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ModelObject } from '../model/modelObject';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {environment} from "../../../environments/environment";


@Injectable()
export class ApiConfigLeadsService {

  protected basePath = environment.api_url;
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   * Ajouter ou modifier une co,fig leads suivant l&#x27;identifiant de l&#x27;organisme
   *
   * @param cle cle de l&#x27;operation update ou create
   * @param idCollab identifiant de collaborateur codé en md5
   * @param value Valeur de config leads
   * @param paramSupp prametre supplementaire de config leads
   * @param idOrg Identifiant de l&#x27;organisme codé en md5
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createUpdateConfigLeadsGet(cle: string, idCollab: ModelObject, value: ModelObject, paramSupp: ModelObject, idOrg?: ModelObject, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public createUpdateConfigLeadsGet(cle: string, idCollab: ModelObject, value: ModelObject, paramSupp: ModelObject, idOrg?: ModelObject, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public createUpdateConfigLeadsGet(cle: string, idCollab: ModelObject, value: ModelObject, paramSupp: ModelObject, idOrg?: ModelObject, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public createUpdateConfigLeadsGet(cle: string, idCollab: ModelObject, value: ModelObject, paramSupp: ModelObject, idOrg?: ModelObject, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    if (cle === null || cle === undefined) {
      throw new Error('Required parameter cle was null or undefined when calling createUpdateConfigLeadsGet.');
    }

    if (idCollab === null || idCollab === undefined) {
      throw new Error('Required parameter idCollab was null or undefined when calling createUpdateConfigLeadsGet.');
    }

    if (value === null || value === undefined) {
      throw new Error('Required parameter value was null or undefined when calling createUpdateConfigLeadsGet.');
    }

    if (paramSupp === null || paramSupp === undefined) {
      throw new Error('Required parameter paramSupp was null or undefined when calling createUpdateConfigLeadsGet.');
    }


    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (cle !== undefined && cle !== null) {
      queryParameters = queryParameters.set('cle', <any>cle);
    }
    if (idOrg !== undefined && idOrg !== null) {
      queryParameters = queryParameters.set('id_org', <any>idOrg);
    }
    if (idCollab !== undefined && idCollab !== null) {
      queryParameters = queryParameters.set('id_collab', <any>idCollab);
    }
    if (value !== undefined && value !== null) {
      queryParameters = queryParameters.set('value', <any>value);
    }
    if (paramSupp !== undefined && paramSupp !== null) {
      queryParameters = queryParameters.set('param_supp', <any>paramSupp);
    }

    let headers = this.defaultHeaders;

    // authentication (Acess_Token) required
    if (this.configuration.apiKeys && this.configuration.apiKeys["idSession"]) {
      headers = headers.set('idSession', this.configuration.apiKeys["idSession"]);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<any>('get',`${this.basePath}/create_update_config_leads`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

}
